import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import type { OrderByDirection } from '@angular/fire/firestore';
import { IconComponent } from '../../icon/icon.component';

/** Arrow button that reverses a sort; the labels say what each direction means, e.g. "Highest first". */
@Component({
  selector: 'app-sort-direction-toggle',
  imports: [IconComponent],
  templateUrl: './sort-direction-toggle.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortDirectionToggle {
  readonly direction = model.required<OrderByDirection>();
  readonly ascLabel = input.required<string>();
  readonly descLabel = input.required<string>();

  protected readonly label = computed(() => (this.direction() === 'asc' ? this.ascLabel() : this.descLabel()));

  protected toggle(): void {
    this.direction.update((direction) => (direction === 'asc' ? 'desc' : 'asc'));
  }
}
